import React from 'react';

const Informacoes = () => {
  return (
    <section className="py-16 bg-[#E8DCC8]" data-testid="informacoes-section">
      <div className="max-w-4xl mx-auto px-4">
        <h2 
          id="informacoes"
          className="text-3xl md:text-4xl font-bold text-[#8B4513] mb-8 text-center scroll-mt-28"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          Informações
        </h2>
        <div className="w-24 h-1 bg-[#DAA520] mx-auto mb-8"></div>
        
        <div className="space-y-6 text-[#4A3728]">
          <div>
            <h3 className="text-xl font-semibold text-[#8B4513] mb-3">Adicionais para seu presente</h3>
            <ul className="space-y-1">
              <li>- Caneca com nome do presenteado R$80</li>
              <li>- Coração de chocolate R$90</li>
              <li>- Orquídeas (valor a conferir)</li>
              <li>- Sapatinho para bebê R$50</li>
              <li>- Caixa de trufas (valor a conferir)</li>
              <li>- Pelúcias diversas (valor a conferir)</li>
              <li>- Champagne "baby" (valor a conferir)</li>
              <li>- Vinho do Cone Sul (valor a conferir)</li>
            </ul>
          </div>

          <div className="bg-[#8B4513] text-[#F5F0E6] p-4 rounded-lg">
            <h4 className="font-bold text-[#DAA520] mb-2">IMPORTANTE</h4>
            <p className="text-sm">
              Os nossos produtos são caseiros e na falta de algum produto, o mesmo será substituído por similar de igual valor e qualidade.
            </p>
          </div>

          <div>
            <h3 id="entregas" className="text-xl font-semibold text-[#8B4513] mb-3 scroll-mt-28">Entregas</h3>
            <p className="mb-4">
              Atendemos toda Belo Horizonte e região metropolitana.
            </p>
            <p className="mb-4">
              É muito importante garantir que tenha alguém no endereço para receber o pedido no momento da entrega. 
              Se o pedido precisar retornar ao nosso endereço, será necessário contratar uma nova entrega e possível perda de perecíveis.
            </p>
            <p>
              Nossa entrega é terceirizada, por isso precisamos que envie o endereço completo para cotarmos 
              a taxa pra você sem compromisso.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-[#8B4513] mb-3">Pagamento</h3>
            <p className="mb-2">Trabalhamos com pagamento antecipado, o mesmo deverá ser feito no momento da encomenda.</p>
            <ul className="list-disc list-inside">
              <li>Pix</li>
              <li>Transferência bancária</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Informacoes;
